import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Table from './Table';
import PropTypes from 'prop-types';
import { styles } from '../../../constants/pdf';
import { marketDynamicsTerms } from '../../../../constants';
import { listingOptions } from '../../../constants/listingViews/overview';

const Report = ({
    chartImage,
    selectedMls,
    listingViewId,
    timeFrameTitle,
    loadedSearchCriteria,
    selectedBeginValue,
    selectedEndValue,
    module,
    searchResults,
    tableView,
    marketIndicatorContent,
    dashboardImage,
    listingViewTitle,
    listingTypeId,
    isComparisonSetView,
    selectedComparisonSet,
    areaTypeTitle,
    listingStatus,
    officeListName,
    selectedTabName,
    exportDetails,
    config,
    selectedAgentProfileArea,
    productionSummary,
}) => {
 
    const isOverview = listingViewId === listingOptions.overview.value;

    const getTempBody = () => {
        const spacers = [];
        
        for (let i = 0; i < 10; i++) {
            spacers.push(
                <p key={`spacer-${i}`} style={{ 
                    height: '200px',
                    margin: '0',
                    padding: '0'
                }}>&nbsp;</p>
            );
        }
        return <div className="spacer-container">{spacers}</div>;
    };

    return (
        <div>
            <style>{styles}</style>
            <Header
                listingViewId={listingViewId}
                timeFrameTitle={timeFrameTitle}
                module={module}
                listingViewTitle={listingViewTitle}
                listingTypeId={listingTypeId}
                isComparisonSetView={isComparisonSetView}
                selectedComparisonSet={selectedComparisonSet}
                areaTypeTitle={areaTypeTitle}
                officeListName={officeListName}
                config={config}
                isOverview={isOverview}
                selectedTabName={selectedTabName}
                agentData={exportDetails?.agentData}
            />
            {chartImage && config?.renderChart({chartImage, isOverview, selectedAgentProfileArea, productionSummary})}
            {isOverview &&
                <div className='column-container-centered'>
                    <div className='market-indicator-text'>
                        {marketIndicatorContent.title}
                    </div>
                    <p className='description-text'>{marketIndicatorContent.description}</p>
                </div>
            }
            {config?.hasTempBody && getTempBody()}
            {dashboardImage &&
                <div className="dashboard-container">
                    <img src={dashboardImage} alt={marketDynamicsTerms.marketDynamicsDashboard} />
                </div>
            }
            {!isOverview && config?.hasTable && <Table
                searchResults={searchResults}
                tableView={tableView}
                config={config}
            />}
            <Footer
                loadedSearchCriteria={loadedSearchCriteria}
                selectedBeginValue={selectedBeginValue}
                selectedEndValue={selectedEndValue}
                selectedMls={selectedMls}
                searchResults={searchResults}
                timeFrameTitle={timeFrameTitle}
                listingTypeId={listingTypeId}
                isComparisonSetView={isComparisonSetView}
                listingStatus={listingStatus}
                areaTypeTitle={areaTypeTitle}
                module={module}
                config={config}
                officeListName={officeListName}
            />
        </div>
    );
};

Report.propTypes = {
    chartImage: PropTypes.string,
    module: PropTypes.string,
    selectedMls: PropTypes.object,
    listingViewId: PropTypes.string,
    timeFrameTitle: PropTypes.object,
    loadedSearchCriteria: PropTypes.object,
    selectedBeginValue: PropTypes.string,
    selectedEndValue: PropTypes.string,
    searchResults: PropTypes.array,
    tableView: PropTypes.object,
    marketIndicatorContent: PropTypes.string,
    dashboardImage: PropTypes.string,
    listingViewTitle: PropTypes.string,
    listingTypeId: PropTypes.string,
    isComparisonSetView: PropTypes.bool,
    selectedComparisonSet: PropTypes.object,
    areaTypeTitle: PropTypes.string,
    listingStatus: PropTypes.string,
    officeListName: PropTypes.string,
    config: PropTypes.object,
    selectedAgentProfileArea: PropTypes.string,
    selectedTabName: PropTypes.string,
    exportDetails: PropTypes.object,
};

export default Report;
